<div class="container-fluid enviroment-state text-center" *ngIf="!environment.production">
    <p class="mb-0">🚀 {{"donants.shared.enviroment.youAre" | translate}} {{"donants.shared.enviroment.test" | translate}} | <span class="capitalize">{{platform}}</span> | {{ appVersion$ | async }} 🚀</p>
</div>